import { Route, Routes } from "react-router-dom";
import LoginLayout from "../components/layouts/login-layout/LoginLayout";
import AdminLayout from "../components/layouts/admin-layout/AdminLayout";
import Login from "../pages/login/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import Story from "../pages/story/Story";
import Video from "../pages/video/Video";
import Banner from "../pages/banner/Banner";
import Post from "../pages/post/Post";
import Article from "../pages/article/Article";
import Event from "../pages/event/Event";
import Course from "../pages/course/Course";
import Payout from "../pages/payout/Payout";
import SkyRoom from "../pages/skyroom/Skyroom";
import User from "../pages/user/User";
import Ticket from "../pages/ticket/Ticket";
import Report from "../pages/report/Report";
import Category from "../pages/category/Category";
import AddCategory from "../pages/add-category/AddCategory";
import Stats from "../pages/stats/Stats";
import Message from "../pages/message/Message";

export default function AppRoutes() {

  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <Routes>
      {!isAuthenticated ? (
        <Route element={<LoginLayout />}>
          <Route path="/" element={<Login />} />
        </Route>
      ) : (
        <Route element={<AdminLayout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/story" element={<Story />} />
          <Route path="/video" element={<Video />} />
          <Route path="/banner" element={<Banner />} />
          <Route path="/post" element={<Post />} />
          <Route path="/article" element={<Article />} />
          <Route path="/event" element={<Event />} />
          <Route path="/course" element={<Course />} />
          <Route path="/payout" element={<Payout />} />
          <Route path="/skyroom" element={<SkyRoom />} />
          <Route path="/user" element={<User />} />
          <Route path="/ticket" element={<Ticket />} />
          <Route path="/report" element={<Report />} />
          <Route path="/category" element={<Category />} />
          <Route path="/add-category" element={<AddCategory />} />
          <Route path="/add-category/:id" element={<AddCategory />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/message" element={<Message />} />
        </Route>
      )}
    </Routes>
  );
};
